/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPaymentCollectionDto } from './GetPaymentCollectionDto';
import {
    GetPaymentCollectionDtoFromJSON,
    GetPaymentCollectionDtoFromJSONTyped,
    GetPaymentCollectionDtoToJSON,
} from './GetPaymentCollectionDto';

/**
 * 
 * @export
 * @interface GetInvoicePaymentDto
 */
export interface GetInvoicePaymentDto {
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetInvoicePaymentDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    amount?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetInvoicePaymentDto
     */
    paymentDate?: Date | null;
    /**
     * 
     * @type {GetPaymentCollectionDto}
     * @memberof GetInvoicePaymentDto
     */
    paymentCollection?: GetPaymentCollectionDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoicePaymentDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    sender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    unlinkedAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoicePaymentDto
     */
    linkedDocuments?: string | null;
}

/**
 * Check if a given object implements the GetInvoicePaymentDto interface.
 */
export function instanceOfGetInvoicePaymentDto(value: object): value is GetInvoicePaymentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetInvoicePaymentDtoFromJSON(json: any): GetInvoicePaymentDto {
    return GetInvoicePaymentDtoFromJSONTyped(json, false);
}

export function GetInvoicePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'title': json['title'] == null ? undefined : json['title'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'paymentCollection': json['paymentCollection'] == null ? undefined : GetPaymentCollectionDtoFromJSON(json['paymentCollection']),
        'active': json['active'],
        'sender': json['sender'] == null ? undefined : json['sender'],
        'unlinkedAmount': json['unlinkedAmount'] == null ? undefined : json['unlinkedAmount'],
        'linkedDocuments': json['linkedDocuments'] == null ? undefined : json['linkedDocuments'],
    };
}

export function GetInvoicePaymentDtoToJSON(value?: GetInvoicePaymentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'systemNumber': value['systemNumber'],
        'title': value['title'],
        'amount': value['amount'],
        'paymentDate': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString()),
        'paymentCollection': GetPaymentCollectionDtoToJSON(value['paymentCollection']),
        'active': value['active'],
        'sender': value['sender'],
        'unlinkedAmount': value['unlinkedAmount'],
        'linkedDocuments': value['linkedDocuments'],
    };
}

